import { MIXPANEL_SERVER_EVENT_NAMES } from '@/lib/mixpanel/constant'

// 使用现有的Mixpanel事件定义
export const CONVERSION_EVENT_TYPES = {
  SIGNUP: MIXPANEL_SERVER_EVENT_NAMES.SIGNUP,
  REFERRAL_SIGNUP: MIXPANEL_SERVER_EVENT_NAMES.REFERRAL_SIGNUP,
  LOGIN: MIXPANEL_SERVER_EVENT_NAMES.LOGIN,
  START_CODING: MIXPANEL_SERVER_EVENT_NAMES.START_CODING,
  FINISH_CODING: MIXPANEL_SERVER_EVENT_NAMES.FINISH_CODING,
  CHECKOUT: MIXPANEL_SERVER_EVENT_NAMES.CHECKOUT,
  ORDER_SUCCESS: MIXPANEL_SERVER_EVENT_NAMES.ORDER_SUCCESS,
  SUBSCRIBE_SUCCESS: MIXPANEL_SERVER_EVENT_NAMES.SUBSCRIBE_SUCCESS,
  SUBSCRIPTION_RENEWAL: MIXPANEL_SERVER_EVENT_NAMES.SUBSCRIPTION_RENEWAL,
  SUBSCRIPTION_CANCELLATION:
    MIXPANEL_SERVER_EVENT_NAMES.SUBSCRIPTION_CANCELLATION,
} as const

export type ConversionEventType =
  (typeof CONVERSION_EVENT_TYPES)[keyof typeof CONVERSION_EVENT_TYPES]

// 事件数据接口
export interface ConversionEventData {
  event_type: ConversionEventType
  user_id?: string
  user_email?: string
  value?: number
  currency?: string
  transaction_id?: string
  ip_address?: string
  user_agent?: string
  referrer_url?: string
  page_url?: string
  ga_client_id?: string
  ga_session_id?: number
  ga_session_number?: number
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_term?: string
  utm_content?: string
  gclid?: string
  wbraid?: string
  gbraid?: string
  event_id?: string // For GA4 MP dedup
  engagement_time_msec?: number // GA4 requires a positive engagement time
  conversion_id?: string // 用于去重
  reddit_click_id?: string // Reddit 点击ID (可选，仅前端可用)
  reddit_uuid?: string // Reddit UUID cookie
  screen_width?: number // 屏幕宽度 (可选)
  screen_height?: number // 屏幕高度 (可选)
  social_fbp?: string // Social browser ID
  social_fbc?: string // Social click ID
  plan_name?: string // 订阅计划名称
  skip_server_ga?: boolean // 是否跳过服务端GA发送，依赖前端gtag
  [key: string]: any
}
